module.exports = __webpack_public_path__ + "static/media/wanderer-bracelets-2.7ec4fb77.jpg";